export const baseEn = {
  header: {
    brand: 'CikaStudio',
    tools: 'Tools',
    games: 'Games',
    about: 'About',
  },
  nav: {
    tools: 'Tools',
    games: 'Games',
    about: 'About',
  },
  actions: {
    copy: 'Copy',
    download: 'Download',
    clear: 'Clear',
    copied: 'Copied!',
    copyAll: 'Copy All',
    downloadTxt: 'Download TXT',
    generate: 'Generate',
    regenerate: 'Regenerate',
    format: 'Format',
    minify: 'Minify',
    validate: 'Validate',
    convert: 'Convert',
  },
  footer: {
    privacy: 'Privacy',
    terms: 'Terms',
    email: 'Contact',
    moreTools: 'More Tools',
    copyright: '© {year} CikaStudio. All rights reserved.',
  },
  language: {
    en: 'English',
    zh: '中文',
  },
  theme: {
    light: 'Light',
    dark: 'Dark',
  },
  common: {
    clientSide: '100% client-side',
    noUpload: 'No data upload',
    noAccount: 'No account required',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
  },
};
